import { createFileRoute, lazyRouteComponent } from "@tanstack/react-router";

export const Route = createFileRoute("/admin/drivers/$id")({
  component: lazyRouteComponent(() => import("./-pages/admin.drivers.$id")),
  head: () => ({
    meta: [
      { title: "Driver report · Lecmo Admin" },
      { name: "robots", content: "noindex" },
    ],
  }),
});
